import { AppContext } from "@/App.context";
import config from "../../config";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";

const getDimensionKey = (token) => {
  return async (Qdata) => {
    let url = `${config.apiHost}/v1/${Qdata?.service}/budget/get-dimentions?scope=${Qdata?.account}`;
    const setBudget = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (!setBudget.ok) {
      const errorResponse = await setBudget.json();
      throw new Error(errorResponse.message);
    }
    const res = await setBudget.json();
    return res;
  };
};

const setDimensionValue = (token) => {
  return async (Qdata) => {
    let url =`${config.reportApiHost}/v1/${Qdata?.service}/reporting/filter/dimension?type=${Qdata?.selectedKey}`
    const setBudget = await fetch(url, {
      method: "GET",
      headers: {
        // "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (!setBudget.ok) {
      const errorResponse = await setBudget.json();
      throw new Error(errorResponse.message);
    }
    const res = await setBudget.json();
    return res;
  };
};

export const useDimensionValue = (queryData, enabled = true) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["setDimensionValue", queryData],
    queryFn: () => setDimensionValue(appContext.idToken)(queryData),
    enabled,
    retry: false,
  });
  return query;
};

export const useDimensionkey = (querydata) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["getDimensionKey", querydata],
    queryFn: () => getDimensionKey(appContext.idToken)(querydata),
    retry: false,
  });
  return query;
};
